export default "__VITE_ASSET__CnR8Wv5G__"